import { render, staticRenderFns } from "./RatioBar.vue?vue&type=template&id=fefb8434&scoped=true&lang=pug&"
import script from "./RatioBar.vue?vue&type=script&lang=ts&"
export * from "./RatioBar.vue?vue&type=script&lang=ts&"
import style0 from "./RatioBar.vue?vue&type=style&index=0&id=fefb8434&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefb8434",
  null
  
)

export default component.exports